import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Button, Input } from '../../../components';
import { useTermsAndConditions } from '../../../context/termsAndConditionContext/TermsAndConditionContextProvider';

const CreateTermsAndConditions = ({ showTermsScreen }) => {
  const {
    terms,
    setTerms,
    createNewTermsAndConditions,
    error,
    updateTermsAndConditions,
  } = useTermsAndConditions();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (terms.id === 0) {
      await createNewTermsAndConditions(terms, showTermsScreen); // Create new terms if id is 0
    } else {
      await updateTermsAndConditions(terms, terms.id, showTermsScreen); // Update existing terms
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTerms((prev) => ({ ...prev, [name]: value })); // Update terms state on input change
  };

  return (
    <form
      className="m-10 bg-slate-50 rounded-2xl p-5"
      onSubmit={handleSubmit} // Use onSubmit for form submission
    >
      <div className="font-600 text-2xl flex justify-between">
        <div>
          {terms.id === 0
            ? 'Create Terms and Conditions'
            : 'Edit Terms and Conditions'}
        </div>
        <div onClick={showTermsScreen} className="hover:cursor-pointer">
          <RxCross2 className="hover:rotate-12" />
        </div>
      </div>
      <div className="flex flex-col items-center grid-cols-1">
        <div className="w-96">
          <Input
            label="Terms And Conditions"
            name="termCondition"
            type="text"
            value={terms.termCondition}
            onChange={handleChange} // Handle input changes
            error={error?.termCondition}
            required
            placeholder="Terms And Conditions"
          />
        </div>
        <div className="flex gap-5 mt-5">
          <Button className="secondary" onClick={showTermsScreen}>
            Cancel
          </Button>
          <Button
            type="submit" // Submit the form on button click
            className="px-4 py-2 bg-yellow-500 text-white rounded-3xl"
          >
            {terms.id === 0 ? 'Submit' : 'Update'}{' '}
            {/* Conditional button text */}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CreateTermsAndConditions;
